import { ElLoading } from 'element-plus'

let loadingInstance: ReturnType<typeof ElLoading.service> | null = null
let loadingCount = 0

const showLoading = () => {
  loadingCount += 1
  if (loadingInstance) return
  loadingInstance = ElLoading.service({
    fullscreen: true,
    text: '加载中...',
    background: 'rgba(0,0,0,0.6)'
  })
}

const hideLoading = () => {
  if (loadingCount > 0) {
    loadingCount -= 1
  }
  if (loadingCount === 0 && loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

export { showLoading, hideLoading }
